;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .factory('VulnerabilitiesService', VulnerabilitiesService)

  function VulnerabilitiesService(
    $rootScope,
    $q,
    $location,
    $routeParams,
    UserService,
    appTracesApiConfig,
    serverVulnsApiConfig,
    orgTraceApiConfig,
    SERVER_ENVIRONMENT_LIST,
    SERVER_ENVIRONMENT_ARRAY
  ) {
    'ngInject'

    var showTraceTable = true,
      me = this

    me.traceCommentPreference = null
    me.traceCommentPreferencePromise = null

    return {
      getShowTraceTable: getShowTraceTable,
      setShowTraceTable: setShowTraceTable,
      showTab: showTab,
      formatStatus: formatStatus,
      formatSeverities: formatSeverities,
      formatTraceDates: formatTraceDates,
      formatEnvironments: formatEnvironments,
      getEnvironmentsText: getEnvironmentsText,
      exportToCSV: exportToCSV,
      exportToXML: exportToXML,
      getTraceEnvironments: getTraceEnvironments,
      hasAppAccess: hasAppAccess,
      getOrgVulnVisibility: getOrgVulnVisibility,
      getAppVulnVisibility: getAppVulnVisibility,
      getServerVulnVisibility: getServerVulnVisibility,
      checkSameApplication: checkSameApplication,
      checkSameApplicationAndRule: checkSameApplicationAndRule,
      getApplicationId: getApplicationId,
      moveToVulnPage: moveToVulnPage
    }

    function getEnvDescription(id) {
      return SERVER_ENVIRONMENT_LIST.find(function (a) {
        return a.value == id
      }).name
    }

    function checkSameApplication(traces) {
      var application, trace, nextApplication

      for (var i = 0; i < traces.length; i++) {
        trace = traces[i]
        nextApplication = getApplicationId(trace)

        if (application) {
          if (application != nextApplication) {
            return false
          }
        } else {
          application = nextApplication
        }
      }
      return true
    }

    function checkSameApplicationAndRule(traces) {
      var application, ruleName, trace, nextApplication

      for (var i = 0; i < traces.length; i++) {
        trace = traces[i]
        nextApplication = getApplicationId(trace)

        if (application) {
          if (application != nextApplication) {
            return false
          }
        } else {
          application = nextApplication
        }

        if (ruleName) {
          if (ruleName != trace.rule_name) {
            return false
          }
        } else {
          ruleName = trace.rule_name
        }
      }
      return true
    }

    function getApplicationId(trace) {
      return trace.parent_application && trace.parent_application != null
        ? trace.parent_application.app_id
        : trace.application.app_id
    }

    function getShowTraceTable() {
      return showTraceTable
    }

    function setShowTraceTable(value) {
      showTraceTable = value
    }

    function showTab(tab) {
      $rootScope.$broadcast('show.tab', { tab: tab })
    }

    function formatStatus(status, current) {
      var result = []
      angular.forEach(status, function (item) {
        var ticked = false
        angular.forEach(current.split(','), function (statusCurrent) {
          if (item.keycode == statusCurrent) {
            ticked = true
          }
        })

        result.push({
          name: item.label,
          value: item.keycode,
          count:
            '<span class="badge badge-danger pull-left">' +
            item.count +
            '</span>',
          disabled: item.count == 0,
          ticked: ticked
        })
      })
      return result
    }

    function formatSeverities(severities, current) {
      var result = []
      angular.forEach(severities, function (severity) {
        var ticked = false

        angular.forEach(current.split(','), function (severityCurrent) {
          if (severity.keycode == severityCurrent) {
            ticked = true
          }
        })

        result.push({
          name: severity.keycode,
          count:
            '<span class="badge badge-danger pull-left">' +
            severity.count +
            '</span>',
          disabled: severity.count == 0,
          ticked: ticked
        })
      })
      return result
    }

    function formatTraceDates(trace) {
      //Window of Exposure
      var windowOfExposureHours = trace.closed_time
        ? moment(trace.closed_time).diff(moment(trace.first_time_seen), 'hours')
        : moment().diff(moment(trace.first_time_seen), 'hours')

      trace.window_of_exposure = parseInt(windowOfExposureHours / 24)
      var remainingHours = windowOfExposureHours % 24

      if (remainingHours >= 12) {
        trace.window_of_exposure++
      }

      return trace
    }

    function formatEnvironments(trace) {
      var environments = {
        DEVELOPMENT: false,
        QA: false,
        PRODUCTION: false
      }
      var i = 0,
        len = trace.server_environments.length
      for (; i < len; i++) {
        var environment = trace.server_environments[i]

        environments[environment] = true
      }

      return environments
    }

    function getEnvironmentsText(trace) {
      var text = ''

      if (!trace.servers) {
        return ''
      }

      var i = 0,
        len = trace.servers.length
      for (; i < len; i++) {
        var server = trace.servers[i]
        text += (text == '' ? '' : ', ') + getEnvDescription(server.environment)
      }

      return text
    }

    function exportToCSV(traces) {
      var tracesObj = []
      angular.forEach(traces, function (trace) {
        tracesObj.push({ name: 'traces', value: trace })
      })

      var data = {
        redirectUrl: UserService.buildAPIUrl('/orgtraces/export/csv'),
        redirectMethod: 'POST',
        redirectData: tracesObj
      }

      $rootScope.$broadcast('trace.export', data)
    }

    function exportToXML(traces) {
      var tracesObj = []
      angular.forEach(traces, function (trace) {
        tracesObj.push({ name: 'traces', value: trace })
      })

      var data = {
        redirectUrl: UserService.buildAPIUrl('/orgtraces/export/xml'),
        redirectMethod: 'POST',
        redirectData: tracesObj
      }
      $rootScope.$broadcast('trace.export', data)
    }

    function getTraceEnvironments(envs) {
      var environments = '',
        env = ''

      for (var i = 0; i < SERVER_ENVIRONMENT_ARRAY.length; i++) {
        env = SERVER_ENVIRONMENT_ARRAY[i]
        if (envs.indexOf(env) > -1) {
          if (environments) {
            environments += ', '
          }
          environments += env
        }
      }
      return environments
    }

    function hasAppAccess(trace, role) {
      if (trace.hasParentApp) {
        if (_.includes(trace.parent_application.roles, 'ROLE_' + role)) {
          return true
        }
      } else {
        if (_.includes(trace.application.roles, 'ROLE_' + role)) {
          return true
        }
      }
      return false
    }

    function _getVulnerabilityVisibility(traceUuid, appId, serverId) {
      var promise = null,
        deferred = $q.defer()

      if (appId) {
        promise = appTracesApiConfig.getVulnerabilityVisibility(
          appId,
          traceUuid
        )
      } else if (serverId) {
        promise = serverVulnsApiConfig.getVulnerabilityVisibility(
          serverId,
          traceUuid
        )
      } else {
        promise = orgTraceApiConfig.getVulnerabilityVisibility(traceUuid)
      }

      promise.then(
        function (response) {
          deferred.resolve(response.data.visible)
        },
        function () {
          deferred.resolve(false)
        }
      )

      return deferred.promise
    }

    function getOrgVulnVisibility(traceUuid) {
      return _getVulnerabilityVisibility(traceUuid)
    }

    function getAppVulnVisibility(traceUuid, appId) {
      return _getVulnerabilityVisibility(traceUuid, appId)
    }

    function getServerVulnVisibility(traceUuid, serverId) {
      return _getVulnerabilityVisibility(traceUuid, null, serverId)
    }

    function moveToVulnPage() {
      if ($routeParams.serverId) {
        $location.path(
          UserService.buildUrl('/servers/' + $routeParams.serverId + '/vulns')
        )
      } else if ($routeParams.appId) {
        $location.path(
          UserService.buildUrl('/applications/' + $routeParams.appId + '/vulns')
        )
      } else {
        $location.path(UserService.buildUrl('/vulns'))
      }
    }
  }
})()
